import { QueryCache, QueryClient } from "@tanstack/react-query";
import { notification } from "antd";

export const GlobalQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Skip error handling if the query has skipGlobalErrorHandler meta flag
      if (query.meta?.skipGlobalErrorHandler) {
        return;
      }
      notification.error({
        message: `Something went wrong: ${error.message}`,
      });
    },
  }),
});

export function getValueByPath(obj: object, path: string) {
  if (!obj || !path) return undefined as any;
  return path.split(".").reduce((acc: any, key: string) => {
    if (acc && key in acc) return acc[key];
    return undefined;
  }, obj) as any;
}

export function setValueByPath<T>(obj: T, path: string, value: unknown): void {
  if (!obj || !path) return;

  const keys = path.replace(/\[(\d+)]/g, ".$1").split(".");
  let current: any = obj;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      if (!current[key] || typeof current[key] !== "object") {
        current[key] = isNaN(Number(keys[index + 1])) ? {} : [];
      }
      current = current[key];
    }
  });
}

export function noCheck(): [boolean, string | undefined] {
  return [true, ""];
}
